import { useCallback, useState } from 'react';
import logger from '../../../utils/logger';

export function useCommentReplyUi(onAddReply) {
  const [replyInputVisible, setReplyInputVisible] = useState({});

  const toggleReplyInput = useCallback((commentKey) => {
    if (!commentKey) return;
    setReplyInputVisible((prev) => ({
      ...prev,
      [commentKey]: !prev[commentKey],
    }));
  }, []);

  const handleAddReply = useCallback(
    (songId, commentId, commentKey, newReply, commentIndex = null) => {
      const stateKey = commentKey || commentId;
      if (!stateKey) return;

      if (commentId == null && commentIndex == null) {
        logger.warn('Unable to add reply: missing comment identifier');
        return;
      }

      // Close the reply form immediately — the reply appears optimistically in the list.
      setReplyInputVisible((prev) => ({ ...prev, [stateKey]: false }));

      Promise.resolve(onAddReply(songId, commentId, newReply, commentIndex)).catch(
        (error) => {
          logger.error('Error adding reply:', error);
        }
      );
    },
    [onAddReply]
  );

  return {
    replyInputVisible,
    toggleReplyInput,
    handleAddReply,
  };
}
